// @flow
import React, { forwardRef } from 'react';
import { Button } from 'semantic-ui-react';
import Header from 'views/Header';
import Hero from 'views/Hero';
import CardContainer from 'components/CardContainer';
import Card from 'components/Card';
import Footer from 'components/Footer';
import { CustomerTypes, VendorTypes } from '../../Constants';
import * as css from './ConfirmComviq.module.css';
import SamsungComviqWatchSvg from './SamsungWatchComviqSvg';
import { getContentFor } from '../../helpers/contentHelpers';

type PropsType = {
  deviceName: string,
  onConfirm: () => void,
  hasAvailablePromotion: boolean,
};

const ComviqContent = ({ deviceName, onConfirm, hasAvailablePromotion }: PropsType) => {
  const allContent = getContentFor(CustomerTypes.FUTUR_COMVIQ);
  const pageContent = allContent.page.confirm;

  const formatText = (text) => {
    return text
      ? text.split('\\n').map((item) => {
          return (
            <>
              {item}
              <br />
            </>
          );
        })
      : '';
  };
  return (
    <>
      <Header isComviq />
      <Hero
        isComviq
        title={pageContent.heroTitle}
        text={pageContent.heroText}
        hasAvailablePromotion={hasAvailablePromotion}
      />
      <CardContainer isComviq>
        <Card as="main" isComviq>
          <div>
            <h2 className={css.title}>{pageContent.title}</h2>
            <p>{formatText(pageContent.text)}</p>
            {window.__VENDOR__ === VendorTypes.APPLE ?
              <svg
                className={css.icon}
                width="54"
                height="70"
                viewBox="0 0 54 70"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M53.25 17.5C53.25 15.1794 52.3281 12.9538 50.6872 11.3128C49.0462 9.67187 46.8206 8.75 44.5 8.75H41.3558C41.1972 8.75012 41.0429 8.69828 40.9165 8.60243C40.7901 8.50657 40.6985 8.37196 40.6558 8.21917L38.6083 1.06458C38.5226 0.75895 38.3396 0.489624 38.0869 0.297491C37.8342 0.105357 37.5258 0.000908347 37.2083 5.33093e-08H16.7917C16.4745 -8.56758e-05 16.166 0.103229 15.9128 0.294286C15.6596 0.485342 15.4757 0.753723 15.3888 1.05875L13.3471 8.21917C13.3046 8.37318 13.2123 8.50878 13.0846 8.60481C12.9569 8.70084 12.801 8.75189 12.6413 8.75H9.5C7.17936 8.75 4.95376 9.67187 3.31282 11.3128C1.67187 12.9538 0.75 15.1794 0.75 17.5V52.5C0.75 54.8206 1.67187 57.0462 3.31282 58.6872C4.95376 60.3281 7.17936 61.25 9.5 61.25H12.6413C12.7995 61.2497 12.9535 61.3011 13.0799 61.3964C13.2063 61.4917 13.298 61.6257 13.3413 61.7779L15.3829 68.9412C15.4701 69.2472 15.6549 69.5163 15.9093 69.7075C16.1636 69.8986 16.4735 70.0014 16.7917 70H37.2083C37.525 69.9995 37.8329 69.8958 38.0855 69.7048C38.338 69.5138 38.5216 69.2458 38.6083 68.9412L40.65 61.7779C40.6936 61.6259 40.7855 61.4922 40.9118 61.397C41.0381 61.3018 41.1919 61.2502 41.35 61.25H44.5C46.8206 61.25 49.0462 60.3281 50.6872 58.6872C52.3281 57.0462 53.25 54.8206 53.25 52.5V17.5ZM47.4167 52.5C47.4167 53.2735 47.1094 54.0154 46.5624 54.5624C46.0154 55.1094 45.2735 55.4167 44.5 55.4167H9.5C8.72645 55.4167 7.98459 55.1094 7.43761 54.5624C6.89062 54.0154 6.58333 53.2735 6.58333 52.5V17.5C6.58333 16.7265 6.89062 15.9846 7.43761 15.4376C7.98459 14.8906 8.72645 14.5833 9.5 14.5833H44.5C45.2735 14.5833 46.0154 14.8906 46.5624 15.4376C47.1094 15.9846 47.4167 16.7265 47.4167 17.5V52.5Z"
                  fill="black"
                />
              </svg>
              : <SamsungComviqWatchSvg className={css.icon} />
            }

            <p className={css.deviceName}>{deviceName}</p>
          </div>
          <Footer isScrolled={false} isComviq>
            <Button primary fluid onClick={onConfirm}>
              {pageContent.button}
            </Button>
          </Footer>
        </Card>
      </CardContainer>
    </>
  );
};

// export default React.memo(ComviqContent);
export default forwardRef(ComviqContent);
